import { dataHooks } from '@wix/data-hooks';

export const navigationDataHooks = dataHooks<{
  root: {};
  menuDropdown: {};
}>('navigation');

export const NAVIGATION_ROOT_ID = 'restaurants-orders-navigation-root';
